import React, { useState } from "react"
import styles from "./Modal.scss"

interface IProps {
  link: string
  closeModal: () => void
  type?: string
}

const options = {
  weezevent: {
    title: "Vous allez être redirigé",
    text: "Weezevent est une billeterie en ligne sécurisée nous permettant de gérer les ventes et paiement des billets pour nos expériences. Pour plus d'informations, n'hésitez pas à visiter leur site à l'aide du lien suivant:",
    links: ["https://weezevent.com/fr"],
    ok: "Passez à l'achat",
    close: "Fermer",
  },
  typeform: {
    title: "Vous allez être redirigé",
    text: "Typeform est un createur de questionnaires en ligne sécurisée intégrant Stripe nous permettant de gérer les ventes et paiement des billets pour nos expériences/koudpouces. Pour plus d'informations, n'hésitez pas à visiter leur site à l'aide du lien suivant:",
    links: ["https://stripe.com/fr", "https://www.typeform.com/"],
    ok: "Choisissez vos dates",
    close: "Fermer",
  },
  info: {
    title: "That's sad... but it's over :(",
    text: "This site is now dead but I kept it online to showcase what it used to be when the company was still up and running. I'm currently using mocked data which is why you'll see duplicated experiences and Lorem lipsum text in the experience details page. Enjoy the ride and contact me if you need any further info !",
    links: [],
    ok: "",
    close: "Close",
  },
}

function Modal({ link = "", closeModal, type = "weezevent" }: IProps) {
  const [disabled, setDisabled] = useState(type === "weezevent")
  function handleCheckboxChange() {
    setDisabled(!disabled)
  }

  const { text, links, title, ok, close } = options[type]

  const renderOkButton = () => {
    if (!ok) {
      return
    }

    return disabled ? (
      <a>Passez à l'achat</a>
    ) : (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={closeModal}
      >
        {ok}
      </a>
    )
  }

  return (
    <div id="popup1" className={styles.overlay}>
      <div className={styles.popup}>
        <h2>{title}</h2>
        <div className={styles.content}>
          {text}
          <br />
          <div id="partnerLinks" key={link}>
            {links.map((l) => (
              <div key={l}>
                <a href={l} target="_blank" rel="noopener noreferrer">
                  {l}
                </a>
              </div>
            ))}
          </div>
        </div>
        <hr />
        {type === "weezevent" && (
          <div>
            <input
              type="checkbox"
              checked={!disabled}
              onChange={handleCheckboxChange}
            />

            <label>
              J'accepte les{" "}
              <a href="/cgu" target="_blank" rel="noopener noreferrer">
                conditions générales de vente
              </a>
            </label>
          </div>
        )}
        <div>
          <button onClick={closeModal}>{close}</button>
          {renderOkButton()}
        </div>
      </div>
    </div>
  )
}

export default Modal
